//import { OCLandInsightsID } from '../../customParameterLayers';
const baseUrl = "https://www.ocgis.com/OCPW/";

export interface OcpwSurveyDataObject {
  title: string;
  type: string;
  getDocumentArray: (attributes: any, download?: boolean) => any[];
}

export class LegalLots implements OcpwSurveyDataObject {
  title;
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) => {
      let apnCode = attributes.AssessmentNo;
      if (apnCode === null || apnCode === undefined) {
        return [];
      } else {
        if (parseInt(apnCode[0]) < 9) {
          return getStandardDocuments(apnCode, download, this.type).concat(
            getStandardDocuments(apnCode, download, this.indexType)
          );
        } else {
          return [];
        }
      }
    }
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  // title:string=OCLandInsightsID.parcels
  type: string = "AM";
  indexType: string = "AMI";
  getDocumentArray;
}

export class AlignmentNotes implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) =>
      getStandardDocuments(
        attributes.BPNUM.replace("&", "_"),
        download,
        this.type
      )
  ) {
    this.getDocumentArray = getDocumentArray;
    this.title = title;
  }
  // title:string=OCLandInsightsID.alignmentNotes
  title;
  type: string = "AN";
  getDocumentArray;
}

export class CertificateOfCompliance implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) =>
      getStandardDocuments(attributes.Name, download, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string=OCLandInsightsID.horizontalControlPoints
  type: string = "CoComp";
  getDocumentArray;
}

export class CityAnnexation implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) => {
      return getStandardDocuments(
        attributes.CityName.concat("-", attributes.AnnexIndex),
        download,
        this.type
      );
    }
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string=OCLandInsightsID.cityAnnexations
  type: string = "CA";
  getDocumentArray;
}

export class CityTies implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) =>
      getStandardDocuments(attributes.DOCPATH, download, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string=OCLandInsightsID.cityTies
  type: string = "CT";
  getDocumentArray;
}

export class CornerRecords implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) =>
      getStandardDocuments(attributes.crnum, download, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string=OCLandInsightsID.cornerRecords
  type: string = "CR";
  getDocumentArray;
}

export class CountySurveyorTieBooks implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) =>
      getStandardDocuments(attributes.BPNUM, download, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string=OCLandInsightsID.countySurveyorTieBooks
  type: string = "CSTB";
  getDocumentArray;
}

export class FloodChannelsAndAsBuilts implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) =>
      getStandardDocuments(attributes.DrawingNum, download, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string=OCLandInsightsID.floodChannelsAndAsBuilts
  type: string = "FAB";
  getDocumentArray;
}

export class HorizontalControl implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) =>
      getStandardDocuments(attributes.GPS, download, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string=OCLandInsightsID.horizontalControlPoints
  type: string = "GEOHO";
  getDocumentArray;
}

export class JackRaubNotes implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) =>
      getStandardDocuments(attributes.FILENAME, download, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string=OCLandInsightsID.jackRaubNotes
  type: string = "JRN";
  getDocumentArray;
}

export class LotLineAdjustment implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) =>
      getStandardDocuments(attributes.Name, download, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string=OCLandInsightsID.lotLineAdjustments
  type: string = "LLA";
  getDocumentArray;
}

export class MiscellaneousDocuments implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) =>
      getStandardDocuments(attributes.Name, download, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string=OCLandInsightsID.miscellaneousDocuments
  type: string = "MD";
  getDocumentArray;
}

export class MiscellaneousRecordsLA implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) =>
      getStandardDocuments(attributes.BPNUM, download, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string=OCLandInsightsID.miscellaneousRecordsLA
  type: string = "MRLA";
  getDocumentArray;
}

export class MonumentRecords implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) =>
      getStandardDocuments(attributes.GPSNUM, download, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string=OCLandInsightsID.MonumentRecords
  type: string = "GPSMR";
  getDocumentArray;
}

export class OcfcdFieldNotes implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) =>
      getStandardDocuments(attributes.File_Name, download, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string=OCLandInsightsID.ocfcdFieldNotes
  type: string = "OCFN";
  getDocumentArray;
}

export class Ocrtn implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) =>
      getStandardDocuments(attributes.GPS, download, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string=OCLandInsightsID.ocrtn
  type: string = "GEOHO";
  getDocumentArray;
}

export class ParcelMap implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) =>
      getStandardDocuments(attributes.Name, download, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string=OCLandInsightsID.parcelMaps
  type: string = "PM";
  getDocumentArray;
}

export class RecordsOfSurvey implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) =>
      getStandardDocuments(attributes.BPNum, download, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string=OCLandInsightsID.recordsOfSurvey
  type: string = "RS";
  getDocumentArray;
}

export class RoadDeed implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) =>
      getStandardDocuments(attributes.Name, download, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string=OCLandInsightsID.roadDeeds
  type: string = "RD";
  getDocumentArray;
}

export class SurveyorMaps implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) =>
      getStandardDocuments(attributes.SMNum, download, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string=OCLandInsightsID.surveyorMaps
  type: string = "SM";
  getDocumentArray;
}

export class SurveyFieldNotes implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) =>
      getStandardDocuments(attributes.FileName, download, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string=OCLandInsightsID.surveyFieldNotes
  type: string = "SFN";
  getDocumentArray;
}

export class TractMap implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) =>
      getStandardDocuments(attributes.Name, download, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string=OCLandInsightsID.tractMaps
  type: string = "TR";
  getDocumentArray;
}

export class TopographicSurveys implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) =>
      getStandardDocuments(attributes.FileName, download, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string=OCLandInsightsID.topographicSurveys
  type: string = "TS";
  getDocumentArray;
}

export class VerticalControlPoints implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any, download: boolean) =>
      getStandardDocuments(attributes.Designation, download, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string=OCLandInsightsID.verticalControlPoints
  type: string = "GEOVE";
  getDocumentArray;
}

/////Right of Way/////
export class Encumbrances implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any) =>
      getROWDocuments(attributes.OBJECTID, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string = OCLandInsightsID.encumbrances;
  type: string = "Encumbrances";
  getDocumentArray;
}

export class FloodParcels implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any) =>
      getROWDocuments(attributes.OBJECTID, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string = OCLandInsightsID.floodParcels;
  type: string = "Flood";
  getDocumentArray;
}

export class MiscFacilities implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any) =>
      getROWDocuments(attributes.OBJECTID, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string = OCLandInsightsID.floodParcels;
  type: string = "MiscFacility";
  getDocumentArray;
}

export class ParkParcels implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any) =>
      getROWDocuments(attributes.OBJECTID, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string = OCLandInsightsID.parkParcels;
  type: string = "OCParks";
  getDocumentArray;
}

export class RoadParcels implements OcpwSurveyDataObject {
  constructor(
    title,
    getDocumentArray = (attributes: any) =>
      getROWDocuments(attributes.OBJECTID, this.type)
  ) {
    this.title = title;
    this.getDocumentArray = getDocumentArray;
  }
  title;
  // title:string = OCLandInsightsID.roadParcels;
  type: string = "Road";
  getDocumentArray;
}

const getStandardDocuments = (field: any, download: boolean, type: string) => {
  let getType;
  if (download) {
    getType = "Get";
  } else {
    getType = "Show";
  }
  if (field) {
    return [
      {
        name: field,
        displayType: "iframe",
        url: `${baseUrl}Services/OCSurvey/Document/${getType}Doc?DocNum=${field.replace(
          " ",
          "%20"
        )}&type=${type}`,
      },
    ];
  } else {
    return [];
  }
};

const getROWDocuments = (field: any, type: string) => {
  if (field) {
    //"https://ocgis.com/ocpw/VestingDocs/Road.html?oid=" + value;
    return [
      {
        name: "Link",
        displayType: "iframe",
        url: `${baseUrl}VestingDocs/${type}.html?oid=${field}`,
      },
    ];
  } else {
    return [];
  }
};
